export enum isCombinationSingleCourse {
  is = 1, // 是组合课中的单课
  not = 0
}

export enum resetResStatus {
  normal = 1, // 正常撤销成功
  isChecked = 2, // 已被审核
  isExpire = 3 // 撤销成功，并且已经过期
}

export enum courseOriginType {
  single = 1,
  combination = 2,
  combinationSingle = 3
}

export enum moneySaleType {
  refunded = '已退款',
  refundApply = '申请退款',
  paidIn = '实付',
  combinationRefund = '组合退款'
}

export enum CourseType {
  combinationCourse = 'package',
  singleCourse = 'app'
}

export enum parentSingleStatusEnum {
  singleRefund = 1,
  singleRefunding = 2,
  singleNoPass = 3,
  singleRefundEntry = 4,
  singleRefunded = 5,
  singleIsStudyed = 6,
  singleSevenOut = 7
}

export interface ParentSingleStatusType {
  singleRefund: number,
  singleRefunding: number,
  singleNoPass: number,
  singleRefundEntry: number,
  singleRefunded: number,
  singleIsStudyed: number,
  singleSevenOut: number
}

export enum parentCombinationStatusEnum {
  combinationRefund = 1,
  combinationRefunding = 2,
  combinationNoPass = 3,
  combinationRefundEntry = 4,
  combinationRefunded = 5,
  combinationSevenOut = 6,
  combinationRefundDisable = 7,
  combinationRefundHideBtn = 8,
  extraPlatformRefund = 9
}

export interface ParentCombinationStatusType {
  combinationRefund: number,
  combinationRefunding: number,
  combinationNoPass: number,
  combinationRefundEntry: number,
  combinationRefunded: number,
  combinationSevenOut: number,
  combinationRefundDisable: number,
  combinationRefundHideBtn: number,
  extraPlatformRefund: number
}

export enum singleStatusEnum {
  refunding = 2, // 审核中
  noPass = 3, // 未通过
  refundEntry = 4, // 退款入账中
  refunded = 5, // 退款成功
  courseStudyed = 6, // 课程已学完
  refundingNotAllow = 10 // 审核中不允许退款
}

export interface SingleStatusType {
  refunding: number;
  noPass: number;
  refundEntry: number;
  refunded: number;
  courseStudyed: number;
}

export enum combinationStatusEnum {
  singleRefund = 1,
  refunding = 2, 
  noPass = 3, 
  refundEntry = 4, 
  refunded = 5, 
  courseStudyed = 6, 
  singleGrayDisable = 7, 
  hideBtn = 8, 
  refundingNotAllow = 10 
};

export interface CombinationStatusType {
  singleRefund: number, 
  refunding: number, 
  noPass: number, 
  refundEntry: number, 
  refunded: number, 
  courseStudyed: number, 
  singleGrayDisable: number, 
  hideBtn: number, 
  refundingNotAllow: number 
};

export enum isGiveEnum {
  isGive = 1, // 是赠品
  notGive = 0 // 不是赠品
}

export enum isSingleEnum {
  isSingle = 1,
  isCombination = 2,
  isBackplatform = 0
}

export enum studyedEnum {
  isStudyed = 1
}

export interface IsGiveEnumType {
  isGive: number;
  notGive: number;
}

export interface IRefundDetailStatus {
  [refundDetailStatus.checking]: string;
  [refundDetailStatus.checkNopass]: string;
  [refundDetailStatus.refundEntry]: string;
  [refundDetailStatus.refunded]: string;
  [refundDetailStatus.checkingNotAllow]: string;
}

export enum refundDetailStatus {
  checking = 1,
  checkNopass = 2,
  refundEntry = 3,
  refunded = 4,
  checkingNotAllow = 5
}

export enum refundEnum {
  refundError = 'error',
  refundSuccess = 'success',
  refundPending = 'pending'
}

export enum pendingProgress {
  submitApply = 0,
  refundExamine = 1
}

export enum itemIndexEnum {
  zero = 0,
  one = 1,
  two = 2
}

export enum ComponentsEnum {
  applyDetail = 'ApplyDetail',
  successApply = 'SuccessApply',
  errorApply = 'ErrorApply'
}

export enum DiscountMethods  {
  coupon = '优惠券差价',
  activity =  '活动退款',
  complaint =  '客诉退款',
  internal =  '内部员工退款',
  deposit = '定金差价'
};

export enum AppParentStatusEnum {
  refunding = 2, // 审核中
  noPass = 3, // 未通过
  refundEntry = 4, // 退款入账中
  refunded = 5, // 退款成功
  refundingNotAllow = 10 // 审核中不允许退款
}

export const applyRefundTextStatus: any = {
  app: [
    AppParentStatusEnum.refunding,
    AppParentStatusEnum.noPass,
    AppParentStatusEnum.refundEntry,
    AppParentStatusEnum.refunded,
    AppParentStatusEnum.refundingNotAllow
  ],
  package: [
    combinationStatusEnum.refunding,
    combinationStatusEnum.noPass,
    combinationStatusEnum.refundEntry,
    combinationStatusEnum.refunded,
    combinationStatusEnum.refundingNotAllow
  ],
}

export const appReturnStatus: any = [
  parentSingleStatusEnum.singleIsStudyed,
  parentSingleStatusEnum.singleSevenOut
]

export const packageReturnStatus: any = [
  parentCombinationStatusEnum.combinationSevenOut,
  parentCombinationStatusEnum.combinationRefundHideBtn,
  parentCombinationStatusEnum.extraPlatformRefund
]

export const appBaseInfo: any = {
  class: {
    1: 'app-apply-refund',
    2: 'combination-refund-examine',
    3: 'combination-refund-nopass',
    4: 'combination-refund-entry',
    5: 'combination-refund-success',
    6: 'course-study-over',
    7: 'course-seven-valid',
    10: 'combination-refund-examine'
  },
  text: {
    1: '申请退款',
    2: '审核中',
    3: '审核不通过',
    4: '退款入账中',
    5: '退款成功',
    6: '课程已学完',
    7: '已过七天可退款时间',
    10: '审核中'
  },
  icon: {
    1: false,
    2: true,
    3: true,
    4: true,
    5: true,
    6: false,
    7: false,
    10: true
  }
};

export const packageBaseInfo: any = {
  class: {
    1: 'package-apply-refund',
    2: 'combination-refund-examine',
    3: 'combination-refund-nopass',
    4: 'combination-refund-entry',
    5: 'combination-refund-success',
    6: 'course-seven-valid',
    7: 'package-apply-refund',
    10: 'combination-refund-examine'
  },
  text: {
    1: '组合退款',
    2: '审核中',
    3: '审核不通过',
    4: '退款入账中',
    5: '退款成功',
    6: '已过七天可退款时间',
    7: '组合退款',
    10: '审核中'
  },
  icon: {
    1: false,
    2: true,
    3: true,
    4: true,
    5: true,
    6: false,
    7: false,
    10: true
  }
};

export const detailTextStatus:any = {
  1: '已退款',
  2: '审核不通过'
}

export const filterDisableStatus: any = [
  combinationStatusEnum.noPass,
  combinationStatusEnum.refunded,
  combinationStatusEnum.courseStudyed
]

export interface ICombination {
  [combinationStatusEnum.singleRefund]: string;
  [combinationStatusEnum.refunding]: string;
  [combinationStatusEnum.noPass]: string;
  [combinationStatusEnum.refundEntry]: string;
  [combinationStatusEnum.refunded]: string;
  [combinationStatusEnum.courseStudyed]: string;
  [combinationStatusEnum.singleGrayDisable]: string;
  [combinationStatusEnum.refundingNotAllow]: string;
}

export interface IIsPlatform {
  [combinationStatusEnum.refunding]: string;
  [combinationStatusEnum.noPass]: string;
  [combinationStatusEnum.refundEntry]: string;
  [combinationStatusEnum.refunded]: string;
  [combinationStatusEnum.refundingNotAllow]: string;
}

export const combinationOrPlatform = {
  [combinationStatusEnum.singleRefund]: {
    class: 'combination-single-refund',
    text: '单课退款'
  },
  [combinationStatusEnum.refunding]: {
    class: 'combination-two-examine',
    text: '组合退款审核中'
  },
  [combinationStatusEnum.noPass]: {
    class: 'combination-two-nopass',
    text: '组合退款不通过'
  },
  [combinationStatusEnum.refundEntry]: {
    class: 'combination-two-entry',
    text: '组合退款入账中'
  },
  [combinationStatusEnum.refunded]: {
    class: 'combination-two-success',
    text: '组合退款成功'
  },
  [combinationStatusEnum.courseStudyed]: {
    class: 'course-study-over',
    text: '课程已学完'
  },
  [combinationStatusEnum.singleGrayDisable]: {
    class:'combination-single-refund',
    text: '单课退款'
  },
  [combinationStatusEnum.refundingNotAllow]: {
    class:'combination-two-examine',
    text: '组合退款审核中'
  }
};

export const isPlatformText = {
  [combinationStatusEnum.refunding]: '后台退款审核中',
  [combinationStatusEnum.noPass]: '后台退款不通过',
  [combinationStatusEnum.refundEntry]: '后台退款入账中',
  [combinationStatusEnum.refunded]: '后台退款成功',
  [combinationStatusEnum.refundingNotAllow]: '后台退款审核中',
};